module.exports = __webpack_public_path__ + "static/img/cards.48e6c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/illus/cards.png
// module id = 178
// module chunks = 9